<template>
	<div :key="'part-color-div' + '-' + rowData.products_id" class="product-data p-x">
		<div class="product-info-content">
			<div class="product-image">
				<img :src="rowData.image" alt="">
			</div>
			<div class="about-product">
				<h5 class="text-white">{{ rowData.title }}</h5>
				<div class="color-selection">
					<div class="color-wrap">
						<template v-for="(color, subIndex) in colors">
							<div
								:key="'part-color-' + subIndex + '-' + color.products_id"
								:class="{'selected': color.selected && partIndex > -1}"
								class="color-wrap-option case-color swatch-color-Black-Red"
								@click="setPartColor(color)"
							>
								<div :id="color.colors ? color.colors : color.colors1.color | lowerCase" class="color1"/>
								<div :id="color.colors2 ? color.colors2.color : color.colors | lowerCase" class="color2"/>
							</div>
						</template>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import duplicate from "@m/duplicate";

export default {
	name: "TabRowColors",
	filters: {
		lowerCase(value) {
			if (!value) {
				return "";
			}
			return value.toString().toLowerCase();
		}
	},
	mixins: [
		duplicate
	],
	props: {
		partName: {
			type: String,
			default: ""
		},
		rowData: {
			type: Object,
			default() {
				return {};
			}
		}
	},
	data() {
		return {
			colors: [],
			partIndex: -1,
			selectedColor: {}
		};
	},
	computed: {
		...mapState({
			activeBuild: state => state.Step4.activeBuild,
			sessionData: state => state.Step4.sessionData
		}),
		...mapGetters(["buildPrice"])
	},
	watch: {
		activeBuild() {
			this.updateColors();
		}
	},
	created() {
		this.colors = _.cloneDeep(this.sessionData.colors[this.partName]);
		this.updateColors();
	},
	methods: {
		...mapActions(["changeBuildPart", "setBuildPrice", "pushBuildPart", "removeBuildPart", "changeActiveRules"]),
		changeBuildPrice(pricingData) {
			if (pricingData.total) {
				if (pricingData.rules) {
					this.changeActiveRules(pricingData.rules);
				}
				this.$store.dispatch("setActiveBuild", pricingData.build);
				this.setBuildPrice(pricingData.total);
			} else {
				if (pricingData.price) {
					this.setBuildPrice(pricingData.price);
				} else {
					this.setBuildPrice(pricingData);
				}
			}
		},
		getBuildPartIndex(productId, part) {
			return _.findIndex(this.sessionData[part], {
				products_id: productId
			});
		},
		getActivePartIndex(productId, part) {
			return _.findIndex(this.activeBuild[part], {
				products_id: productId
			});
		},
		async setPartColor(selectedColor) {
			if (await this.checkOwnership()) {
				this.colors = this.colors.map((color) => {
					color.selected = (color.id === selectedColor.id);

					return color;
				});

				axios({
					url: `/update-part/${selectedColor.id}/1?pid=${selectedColor.products_id}&validate=true&step4=true`,
					method: "GET",
					headers: {
						"token": CONFIG.SESSION
					}
				}).then((response) => {
					this.changeBuildPrice(response.data);
				});
			} else {
				await this.duplicateBuild();
				await this.getSessionData();
				this.setPartColor(selectedColor);
			}
		},
		updateColors() {
			this.partIndex = this.getActivePartIndex(this.rowData.products_id, this.partName);
			this.colors = this.colors.map((color) => {
				color.selected = this.partIndex > -1 && (color.color_fullname == this.activeBuild[this.partName][this.partIndex].colors);

				return color;
			});
		}
	}
};
</script>
